import { useEffect, useState } from "react";
import useGeoData from "./useGeoData";
import { FORM_ERROR_MESSAGES } from "Constant";

interface UseMasterLocationProps {
  tinhThanhPho: string;
  quanHuyen: string;
  enabled?: boolean;
}
export const useMasterLocation = (props: UseMasterLocationProps) => {
  const { tinhThanhPho, quanHuyen, enabled } = props;
  const {
    useTinhThanhPhos,
    useQuanHuyensByTinhThanhPho,
    usePhuongXasByQuanHuyen,
  } = useGeoData();
  const { data: tinhThanhPhos } = useTinhThanhPhos({
    enabled,
  });
  const [selectedTinhThanhPho, setSelectedTinhThanhPho] =
    useState<string>(tinhThanhPho);
  const [selectedQuanHuyen, setSelectedQuanHuyen] = useState<string>(quanHuyen);
  const { data: quanHuyens } =
    useQuanHuyensByTinhThanhPho(selectedTinhThanhPho);

  const { data: phuongXas } = usePhuongXasByQuanHuyen(selectedQuanHuyen);

  useEffect(() => {
    if (tinhThanhPho !== selectedTinhThanhPho) {
      setSelectedTinhThanhPho(tinhThanhPho);
    }
  }, [tinhThanhPho]);

  useEffect(() => {
    if (quanHuyen !== selectedQuanHuyen) {
      setSelectedQuanHuyen(quanHuyen);
    }
  }, [quanHuyen]);

  return {
    tinhThanhPhos,
    quanHuyens,
    phuongXas,
    selectedQuanHuyen,
    selectedTinhThanhPho,
    setSelectedTinhThanhPho,
    setSelectedQuanHuyen,
    formFields: [
      {
        name: "masterTinhThanhPhoId",
        label: "Tỉnh/Thành phố",
        type: "select",
        options:
          tinhThanhPhos?.map((item) => ({
            value: item.id,
            text: item.ten,
          })) || [],
        rules: {
          required: FORM_ERROR_MESSAGES.REQUIRED,
        },
        onChange: (value: string) => {
          setSelectedTinhThanhPho(value);
          setSelectedQuanHuyen("");
        },
      },
      {
        name: "masterQuanHuyenId",
        label: "Quận/Huyện",
        type: "select",
        options:
          quanHuyens?.map((item) => ({
            value: item.id,
            text: item.ten,
          })) || [],
        rules: {
          required: FORM_ERROR_MESSAGES.REQUIRED,
        },
        onChange: (value: string) => {
          setSelectedQuanHuyen(value);
        },
        disabled: !selectedTinhThanhPho,
      },
      {
        name: "masterPhuongXaId",
        label: "Phường/Xã",
        type: "select",
        options:
          phuongXas?.map((item) => ({
            value: item.id,
            text: item.ten,
          })) || [],
        rules: {
          required: FORM_ERROR_MESSAGES.REQUIRED,
        },
        disabled: !selectedQuanHuyen,
      },
    ],
  };
};
